<template>
  <div class="filters" :style="{ '--source-color': `var(--${color}-main)` }">
    <!-- Main source -->
    <div class="filters__mainsource">
      <FilterMainSource></FilterMainSource>
      <div class="filters__mainsource--timestamp">
        <div>
          Data related to
          <span class="filters__mainsource--timestamp-date">
            {{ lastUpdated }}
          </span>
        </div>
        <div class="filters__mainsource--timestamp-update">
          {{ metadatum.dataUpdate || "" }}
        </div>
      </div>
    </div>

    <!-- source -->
    <div v-if="hasSource" class="filters__source">
      <FilterSource></FilterSource>
    </div>

    <!-- Others -->
    <div class="filters__others" v-if="hasDataType || hasGeoAreas">
      <FilterDataType
        v-if="hasDataType"
        :direction="hasSource ? 'row' : 'column'"
      ></FilterDataType>

      <FilterGeoArea
        v-if="hasGeoAreas"
        :direction="hasSource ? 'row' : 'column'"
      ></FilterGeoArea>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FilterGeoArea from "./FilterGeoArea";
import FilterSource from "./FilterSource";
import FilterMainSource from "./FilterMainSource";
import FilterDataType from "./FilterDataType";

import getUomAndMetadatum from "@/mixins/getUomAndMetadatum";
export default {
  name: "Filters",
  mixins: [getUomAndMetadatum],
  components: {
    FilterGeoArea,
    FilterSource,
    FilterMainSource,
    FilterDataType,
  },
  computed: {
    sources() {
      return this.sourceConfig.sources;
    },
    dataTypes() {
      return this.sourceConfig.dataTypes;
    },
    hasSource() {
      return this.sourceConfig && this.sourceConfig.sources ? true : false;
    },
    hasDataType() {
      return this.sourceConfig && this.sourceConfig.dataTypes ? true : false;
    },
    hasGeoAreas() {
      return this.sourceConfig && this.sourceConfig.geoAreas ? true : false;
    },
    color() {
      return this._color();
    },

    ...mapGetters({
      source: "ui/source",
      sourceConfig: "ui/currentSourceConfig",
      geoArea: "ui/geoArea",
      lastUpdated: "data/getLastUpdated",
      _color: "ui/sourceColor",
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.initFiltersStatus();
    });
  },

  methods: {
    initFiltersStatus() {
      // set new status according to current source
      this.initDataTypeStatus();
      this.initSourceStatus();
      this.initGeoAreaStatus();

      // console.log('COLOR',this.sourceConfig.colorName);

      this.calcData();
    },

    initGeoAreaStatus() {
      if (this.hasGeoAreas) {
        const current = this.geoArea;

        if (current !== null) {
          // if old source and new source share geoArea, keep it
          this.setGeoArea(current);
        } else {
          // set the first one selected
          this.setGeoArea("World");
        }
      } else {
        this.setGeoArea("World");
      }
    },
    initDataTypeStatus() {
      if (this.hasDataType) {
        const current = this.dataType;

        if (current !== null && this.dataTypes.indexOf(current) > -1) {
          // if old source and new source share dataType, keep it
          this.setDataType(current);
        } else {
          // set the first one selected
          this.setDataType(this.dataTypes[0]);
        }
      } else {
        this.setDataType(null);
      }
    },
    initSourceStatus() {
      if (this.hasSource) {
        this.setSource(this.sources[0].key);
      } else {
        this.setSource(null);
      }
    },

    ...mapActions({
      setSource: "ui/setSource",
      setDataType: "ui/setDataType",
      setGeoArea: "ui/setGeoArea",
      calcData: "data/calcData",
    }),
  },
  watch: {
    $route() {
      // when route change reset all filters then set new ones if needed
      this.initFiltersStatus();
    },
  },
};
</script>
<style lang="scss" scoped>
.filters {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  transition: all 0.4s ease;
  background-color: var(--source-color);

  &__mainsource {
    @include filter-row;

    width: 100%;
    display: flex;
    flex-shrink: 0;

    &--timestamp {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      margin-right: toRem(13);
      align-items: flex-end;
      @include number-S;
      color: $ui-white;

      &-date {
        color: $primary-yellow;
        margin-left: 2px;
      }
      &-update {
        font-style: italic;
      }
    }
  }

  &__source {
    width: 100%;
    height: 100%;
    @include filter-row;
    flex-shrink: 0;
  }

  &__others {
    @include filter-row;
    flex-grow: 1;
    padding-top: toRem(10);
    padding-bottom: toRem(10);
  }
}
</style>